import { axiosRequest, type AxiosResult } from "@/lib/axios";
import type { WallOfLove, WallOfLoveRequest, WallOfLoveUpdateRequest, WallPreviewRequest, WallPreviewResponse } from "../types";

const API_BASE_URL = import.meta.env.VITE_SERVICE_CORE_URL;

export const wallOfLoveApi = {
	index: (workspaceId: string): Promise<AxiosResult<WallOfLove[]>> => {
		return axiosRequest({ url: `${API_BASE_URL}/${workspaceId}/walls`, method: "GET" });
	},

	show: (id: string, workspaceId: string): Promise<AxiosResult<WallOfLove>> => {
		return axiosRequest({ url: `${API_BASE_URL}/${workspaceId}/walls/${id}`, method: "GET" });
	},

	create: (workspaceId: string, payload: WallOfLoveRequest): Promise<AxiosResult<WallOfLove>> => {
		return axiosRequest({ url: `${API_BASE_URL}/${workspaceId}/walls`, method: "POST", data: payload });
	},

	update: (id: string, workspaceId: string, payload: WallOfLoveUpdateRequest): Promise<AxiosResult<WallOfLove>> => {
		return axiosRequest({ url: `${API_BASE_URL}/${workspaceId}/walls/${id}`, method: "PATCH", data: payload });
	},

	delete: (id: string, workspaceId: string): Promise<AxiosResult<void>> => {
		return axiosRequest({ url: `${API_BASE_URL}/${workspaceId}/walls/${id}`, method: "DELETE" });
	},

	restore: (id: string, workspaceId: string): Promise<AxiosResult<WallOfLove>> => {
		return axiosRequest({ url: `${API_BASE_URL}/${workspaceId}/walls/${id}/restore`, method: "PUT" });
	},

	syncStaticReviews: (workspaceId: string, wallId: string, reviewIds: string[]): Promise<AxiosResult<void>> => {
		return axiosRequest({
			url: `${API_BASE_URL}/${workspaceId}/walls/${wallId}/reviews-curated`,
			method: "PUT",
			data: { review_ids: reviewIds },
		});
	},

	syncPinnedReviews: (workspaceId: string, wallId: string, reviewIds: string[]): Promise<AxiosResult<void>> => {
		return axiosRequest({
			url: `${API_BASE_URL}/${workspaceId}/walls/${wallId}/reviews-pinned`,
			method: "PUT",
			data: { review_ids: reviewIds },
		});
	},

	indexPinnedReviews: (workspaceId: string, wallId: string): Promise<AxiosResult<WallOfLove[]>> => {
		return axiosRequest({
			url: `${API_BASE_URL}/${workspaceId}/walls/${wallId}/reviews-pinned`,
			method: "GET",
		});
	},

	preview: (workspaceId: string, payload: WallPreviewRequest, cursor?: string | null): Promise<AxiosResult<WallPreviewResponse>> => {
		const url = cursor ? `${API_BASE_URL}/${workspaceId}/walls/preview?cursor=${encodeURIComponent(cursor)}` : `${API_BASE_URL}/${workspaceId}/walls/preview`;
		return axiosRequest({
			url,
			method: "POST",
			data: payload,
		});
	},
};
